import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1507d54e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507d54e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1507d54e')) {
      api.createRecord('1507d54e', component.options)
    } else {
      api.reload('1507d54e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1507d54e&scoped=true&", function () {
      api.rerender('1507d54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ib6qkiS439YT/JS/comp/Accordion.vue"
export default component.exports